import $ from 'jquery';
import _ from 'underscore';

/**
 * Add data to dataLayer for links
 * @param {Event} event - click event
 * @param {Object} data
 */
export function addToDataLayerForLinks(event, data) {
    var href = event.target.href || $(event.currentTarget).prop('href');
    var redirectCallback;
    var redirectTimeout;
    var timeoutTime = 500;

    if (typeof href === 'string') {
        event.preventDefault();

        redirectCallback = _.bind(function () {
            clearTimeout(redirectTimeout);
            _redirect(href);
        }, this);

        redirectTimeout = setTimeout(function () {
            redirectCallback();
        }, timeoutTime);

        data.eventCallback = redirectCallback;

        window.dataLayer.push(data);
    }
}

export function _redirect(href) {
    document.location.assign(href);
}

/**
 * Method return first state of dataLayer object
 * @return {Object}
 */
export function getCurrentDataLayer() {

    var blackListKey = 'event';
    var result = {};

    if (typeof window.dataLayer !== 'undefined') {
        var resultArray = _.reject(window.dataLayer, function (currentLayer) {
            return currentLayer[blackListKey];
        });

        if (resultArray.length > 0) {
            result = resultArray[0];
        }
    }

    return result;
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/tracking/common/helper.js
 **/